// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1zvQI","footer":"ModalError_footer__Ow4sv"};